import styled, { css } from "styled-components";

export default styled.div(({ theme }) => css`
  margin: 30px 0px;

  .label-desktop {
    width: 0;
    display: none;
    z-index: 1;

    @media only screen and (min-width: ${theme.breakpoints.XM}) {
      display: block;
    }
  }

  .label-mobile {
    display: block;
    padding: 0 20px;

    @media only screen and (min-width: ${theme.breakpoints.XM}) {
      display: none;
    }
  }
  
  .nav-svg {
    position: relative;
    display: block;
    flex: 0 0 24px;
    width: 24px;
    height: 24px;
    line-height: 0;
    z-index: 2;
    background: ${theme.palette.header.background};
    color: ${theme.palette.header.icon};
    padding: ${(props) =>
      props.justifyAttribute === "left"
        ? "0px 0px 0px 17px"
        : "0px 17px 0px 0px"};

    .fill {
      fill: currentColor;
      transition: fill 0.35s ease;
    }
  }

  .link-container {
    display: flex;
    flex-direction: ${(props) =>
      props.justifyAttribute === "left" ? "row" : "row-reverse"};
    align-items: center;
    justify-content: ${(props) =>
      props.justifyAttribute === "left" ? "flex-start" : "end"};
    text-decoration: none;
    margin-bottom: 15px;
    overflow: hidden;

    p {
      color: ${theme.palette.header.color};
      font-weight: ${theme.fonts.headingWeight};
      margin: ${(props) =>
        props.justifyAttribute === "left" ? "0 0 0 10px" : "0 10px 0 0"};
      transition: 0.15s color linear;
      word-break: normal;
      white-space: nowrap;
      overflow: hidden;
      text-align: ${(props) =>
        props.justifyAttribute === "left" ? "left" : "right"};
    }

    @media (hover: hover) {
      &:hover {
        p {
          color: ${theme.palette.header.active};
        }

        .nav-svg  .fill {
          fill: ${theme.palette.header.iconActive};
        }
      }
    }


    &.active {
      p {
        color: ${theme.palette.header.active};
      }

      .nav-svg .fill {
        fill: ${theme.palette.header.iconActive};
      }
    }
  }

  @media only screen and (min-width: ${theme.breakpoints.XM}) {
    .link {
      text-decoration: none;
    }
    .link-container {
      p {
        color: ${theme.palette.header.color};
      }
    }
  }
`);
